// Delivery Station - Delivery coordination and management
import React from 'react';
import { Truck } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const DeliveryStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="delivery"
      stationName="Ready for Delivery"
      stationIcon={<Truck className="w-6 h-6" />}
      stationColor="#84CC16"
      showAdvanceButton={false} // No advance button - orders are finished when delivered
      showCustomerContact={true} // Show contact info for delivery coordination
      showDeliveryInfo={true} // Show delivery address
    />
  );
};

export default DeliveryStation;
